import React from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Shared placeholder for general pages (Help, Contact, Privacy Policy, Error).
 * Displays a "Coming soon" style block with an optional title.
 */
function PlaceholderPage({ title }) {
  const { t } = useTranslation()
  const displayTitle = title != null ? title : (t('coming_soon') || 'Coming soon')
  return (
    <section className="section section-lg bg-gray-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6 text-center">
            <h3 className="mb-4">{displayTitle}</h3>
            <p className="text-gray-600">{t('page_coming_soon') || 'This page is coming soon.'}</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PlaceholderPage
